import { array, object, string } from 'yup';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_30_LENGTH, MAX_255_LENGTH } from '@constants/validationMessages';

export const schema = object({
	setupName: string()
		.trim()
		.default('')
		.max(MAX_255_LENGTH, getMaxLengthErrMsg('Setup Name', MAX_255_LENGTH))
		.required(validationErrMessages.setupName),
	logoId: string()
		.trim()
		.default('')
		.required(validationErrMessages.logoIcon),
	logoCaption: string()
		.trim()
		.default('')
		.max(MAX_30_LENGTH, getMaxLengthErrMsg('Logo Caption', MAX_30_LENGTH)),
	organisations: array().nullable(),
});
